import _ from "lodash";
import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { api } from '../utils';

export default function useGetSampleOrProductionSetup(itemObj) {
   const { selectedItem } = itemObj;
   const [item, setItem] = useState({ success: false, item: {}, loading: false, header: "" });

   useEffect(() => {
      if (!selectedItem && !selectedItem?.value?.length) return;
      if (_.isEqual({ itemObj: item?.itemObj }, { itemObj: itemObj.selectedItem })) return;
      setItem({ ...item, itemObj: itemObj.selectedItem, loading: true })

      // escape the forward slash character or pound symbol if in the item so it won't mess up the URL
      // Example = MP.11/64S40007 this causes the url to look like it has an extra parameter because
      // of the / character so the URL is broken and a Not Found error is thrown.
      var encodedItem = selectedItem?.value.replace(/\//g, '%2F').replace(/#/g, '%23') || "";
      api.fetch(`Inventory/GetSampleOrProductionItemInfo/${encodedItem}`)
         .then(response => {
            if (response?.data?.success) {
               if (response.data.productionItemRequest) {
                  setItem({ success: true, item: response.data.productionItemRequest, loading: false, header: "Production Setup" });
               } else {
                  if (_.isEmpty(response.data.sampleItemRequest)) {
                     setItem({ success: false, item: {}, loading: false, header: "" })
                  } else {
                     setItem({ success: true, item: response.data.sampleItemRequest, loading: false, header: "Sample Request Setup" });
                  }
               }
            } else {
               toast.error("SampleOrProductionItemInfo Info query returned an error")
            }
         })
         .catch(api.catchHandler)

      return () => {
         setItem({ success: false, item: {}, loading: false, header: "" });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [itemObj]);

   return item;
}